module.exports = __webpack_public_path__ + "static/img/4.b9ca91b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/1/sp/4.png
// module id = SM1q
// module chunks = 0